<h1 mat-dialog-title>Remove Item</h1>
<div mat-dialog-content>
    <p>
        What should happen to <span class="name">{{ data.asset.name }}</span> when removed from the
        <span class="name">{{ data.review.name }}</span> review?
    </p>

    <table>
        <tr>
            <td>
                <button
                    mat-stroked-button
                    color="accent"
                    [mat-dialog-close]="false"
                    (click)="remove()"
                >
                    Remove
                </button>
            </td>
            <td>Remove it from the review and put it into the same Stream as the review?</td>
        </tr>
        <tr>
            <td>
                <button
                    mat-stroked-button
                    color="warn"
                    [mat-dialog-close]="true"
                    (click)="delete()"
                >
                    Delete
                </button>
            </td>
            <td>Just delete it from the workspace?</td>
        </tr>
    </table>
</div>
<div mat-dialog-actions>
    <button mat-button mat-dialog-close>Cancel</button>
</div>
